import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { IDatePickerConfig } from 'ng2-date-picker';
import { Subject } from 'rxjs/internal/Subject';
import * as filesaver from 'file-saver';
import { checkIfEndDateAfterStartDate, dateFormat, numberFormat } from 'src/app/shared/validators/custom.validators';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { TransactionRepo } from 'src/app/repositories/transaction-repo';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertParameters, AlertType } from '../../models/models-index';
import { AlertService } from 'src/app/services';
import { ReportType } from '../../models/report-type';

@Component({
    selector: 'app-modal-export-stations-transactions',
    templateUrl: './modal-export-stations-transactions.component.html',
    styleUrls: ['./modal-export-stations-transactions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalExportStationsTransactionsComponent implements OnInit {

  isDownloadLoading = false;
  reportTypes!: ReportType[];
  destroyed$ = new Subject<void>();
  language: 'fr' | 'en' = 'fr';
  datePickerConfig: IDatePickerConfig = {
    disableKeypress: false,
    format: 'DD/MM/YYYY',
    monthFormat: 'MMMM, YYYY',
    firstDayOfWeek: 'mo',
    showTwentyFourHours: true,
    showSeconds: false,
    showGoToCurrent: true,
    showNearMonthDays: false,
    hideOnOutsideClick: true,
    enableMonthSelector: true,
    allowMultiSelect: false
  };

  now = moment.default();
  validityStartDisplayDate =  moment.default().subtract(1, 'months');
  validityEndDefault = this.now;
  validityEndDisplayDate = this.validityEndDefault;
  subscriptions = new Subscription();

  // FORM
  get f() {
    return this.exportForm.controls;
  }
  exportForm = this.fb.group({
    validityStart: [null, dateFormat(this.datePickerConfig.format)],
    validityEnd: [this.validityEndDefault, [Validators.required, dateFormat(this.datePickerConfig.format)]],
  });

  endDatePickerConfig = this.datePickerConfig;
  startDatePickerConfig = this.datePickerConfig;

  constructor(private fb: UntypedFormBuilder,
    private transactionRepo: TransactionRepo,
    private alertService: AlertService,
    public translate: TranslateService,
    private dialogRef: MatDialogRef<ModalExportStationsTransactionsComponent> 
    ) { }

  ngOnInit(): void {
    this.reportTypes = Object.values(ReportType);
    this.exportForm.get('validityStart').patchValue(this.validityStartDisplayDate.startOf('day'));
    this.exportForm.get('validityEnd').patchValue(moment.default().startOf('day'));
    this.exportForm.addValidators(checkIfEndDateAfterStartDate('validityStart', 'validityEnd'));
  }

  onSubmit() {
    this.exportForm.markAllAsTouched();
    const formValues = this.exportForm.getRawValue();
    const start =  formValues.validityStart ? moment.default(formValues.validityStart) : null ;
    const end: moment.Moment = moment.default(formValues.validityEnd);

    if (this.exportForm.valid) {
      this.isDownloadLoading = true;
      const params = [];
      params.push({ key: 'startDate', value: start.toISOString() });
      params.push({ key: 'endDate', value: end.toISOString() });

      this.subscriptions.add(
        this.transactionRepo.exportTransactions(params)
          .subscribe({
            next: (response) => {
              const filename = response.headers
                .get('content-disposition')
                .split('=');
              const blob = new Blob([response.body], {
                type: response.headers.get('content-type'),
              });
              filesaver.saveAs(blob, filename[1].slice(1, -1));
              this.isDownloadLoading = false;
              this.dialogRef.close();
            },
            error: (error) => {
              this.isDownloadLoading = false;
              this.showAlert(error);
            },
          })
      );
    }
  }

  showAlert(error: any) {
    const title = this.translate.instant('error.title');
    const alertParams = new AlertParameters(
      false,
      false,
      true,
      false,
      false,
      false,
      true,
      title
    );
    this.alertService.showAlert(error, AlertType.ERROR, alertParams);
  }

}

